module.exports = __webpack_public_path__ + "img/norway-diseases-of-the-nervous-system-male.885df586.png";